export const canvasToFile = (canvas) => {
    return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            const file = new File([blob], 'cropped-image.jpeg', {
                type: 'image/jpeg',
                lastModified: new Date().getTime(),
            });
            return resolve({ file, cropped: canvas.toDataURL('image/jpeg') });
        });
    });
};
